/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Run_Approval_Preselected_ApproveInputs */



/**
* | output |
* | --- |
* | "You chose Approve in the email. Click Approve to confirm it." |
*
* @param {Agent_Run_Approval_Preselected_ApproveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_run_approval_preselected_approve = /** @type {((inputs?: Agent_Run_Approval_Preselected_ApproveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Run_Approval_Preselected_ApproveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sie haben in der E-Mail „Freigeben“ gewählt. Klicken Sie zur Bestätigung auf „Freigeben“.")
	return /** @type {LocalizedString} */ ("You chose Approve in the email. Click Approve to confirm it.")
});